import { useMutation } from '@tanstack/react-query';

import { handleAxiosError } from '../../CommonFuctions/handleAxiosError';
import { axiosDocChatInstance } from '../../lib/axiosDocChatInstance';

// The endpoint always returns a Word document.
const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const FALLBACK_FILENAME = 'chat-response.docx';

const downloadResponseMutationFn = async ({ downloadUrl, fileName }) => {
  const response = await axiosDocChatInstance.get(downloadUrl, { responseType: 'blob' });

  const blob =
    response.data instanceof Blob && response.data.type
      ? response.data
      : new Blob([response.data], { type: DOCX_MIME });

  const objectUrl = window.URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName || FALLBACK_FILENAME;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    window.URL.revokeObjectURL(objectUrl);
  }
};

// Downloads a chat response that was too large to inline.
export const useDownloadResponse = () => {
  const { mutate: downloadResponse, isPending: downloading } = useMutation({
    mutationFn: downloadResponseMutationFn,
    onError: (error) => {
      handleAxiosError(error);
      console.error('Download chat response failed', error);
    },
  });

  return { downloadResponse, downloading };
};
